import type { NavItem } from '../types'

export const topicGuides: NavItem = {
  name: 'Topic Guides',
  linkSections: [
    {
      columns: 2,
      sections: [
        {
          header: 'Quantum Computing Topic Guides from PennyLane',
          items: [
            {
              name: 'Fault-tolerant quantum computing',
              href: '/topics/fault-tolerant-quantum-computing',
              description:
                'Master the latest advancements in error correcting codes and FTQC.',
            },
            {
              name: 'Hamiltonian simulation',
              href: '/topics/hamiltonian-simulation',
              description:
                'Discover Hamiltonian simulation algorithms–from basic to advanced techniques.',
            },
            {
              name: 'Quantum compilation',
              href: '/topics/quantum-compilation',
              pill: {
                text: 'New',
                variant: 'in-progress',
                startDate: '2026-06-19',
                expiryDate: '2026-07-22',
              },
              description:
                'Explore the definitive PennyLane Guide to quantum compilation techniques.',
            },
            {
              name: 'Quantum gradients',
              href: '/topics/quantum-gradients',
              description:
                'Access a curated guide of the different quantum gradient methods.',
            },
            {
              name: 'Quantum hardware',
              href: '/topics/quantum-hardware',
              description:
                'View how the modalities stack up in the global race to build a scalable quantum computer.',
            },
            {
              name: 'Quantum machine learning',
              href: '/topics/quantum-machine-learning',
              description:
                'Learn the different flavours of quantum machine learning in this curated guide.',
            },
          ],
        },
      ],
    },
  ],
  cardSections: [
    {
      header: 'Featured PennyLane Topic Guides',
      type: 'featured',
      cards: [
        {
          variant: 'white',
          title: 'Fault-tolerant quantum computing',
          description: `Master the latest advancements in error correcting codes and FTQC.`,
          imageSrc:
            'https://assets.cloud.pennylane.ai/navbar/topic-guides-ftqc-wide.png',
          imageSize: 'full',
          button: {
            text: 'Demystify FTQC',
            variant: 'secondary',
          },
          href: '/topics/fault-tolerant-quantum-computing',
        },
        {
          variant: 'white',
          title: 'Quantum compilation',
          description: `Explore the definitive PennyLane Guide to quantum compilation techniques.`,
          imageSrc:
            'https://assets.cloud.pennylane.ai/navbar/topic-guides-compilation-wide.png',
          imageSize: 'full',
          button: {
            text: 'Explore quantum compilation',
            variant: 'secondary',
          },
          href: '/topics/quantum-compilation',
          pill: {
            text: 'New',
            variant: 'in-progress',
            startDate: '2026-06-19',
            expiryDate: '2026-07-22',
          },
        },
      ],
    },
  ],
}
